export interface Category {
  id: string;
  name: string;
  description: string;
  icon: string;
  image: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'agricultural',
    name: '农业喷水灌溉',
    description: '覆盖大田喷灌、设施农业微喷、果园滴灌等农业喷水全场景方案，助力精准灌溉、节水增产。',
    icon: 'ri-plant-line',
    image: 'https://readdy.ai/api/search-image?query=Vast%20green%20agricultural%20field%20with%20modern%20sprinkler%20irrigation%20system%20spraying%20water%20mist%20under%20golden%20sunrise%20light%2C%20rolling%20hills%20background%2C%20professional%20farming%20photography%2C%20clean%20natural%20composition%2C%20warm%20earthy%20tones&width=800&height=500&seq=cat-agri-01&orientation=landscape',
    articleCount: 3
  },
  {
    id: 'landscape',
    name: '景观喷水装置',
    description: '从城市广场音乐喷泉到园林水景设计，提供创意景观喷水装置的规划、设计与实施方案。',
    icon: 'ri-water-flash-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20urban%20park%20water%20fountain%20design%20with%20dancing%20water%20jets%20surrounded%20by%20lush%20greenery%2C%20modern%20city%20skyline%20in%20distance%2C%20warm%20afternoon%20sunlight%2C%20professional%20landscape%20architecture%20photography%2C%20serene%20atmosphere&width=800&height=500&seq=cat-land-01&orientation=landscape',
    articleCount: 2
  },
  {
    id: 'industrial',
    name: '工业喷水冷却',
    description: '专注工业冷却塔喷水系统、蒸发冷却技术及工艺喷水方案，为企业节能降耗提供可靠保障。',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20cooling%20system%20with%20large%20cooling%20towers%20and%20water%20spray%20mist%20at%20sunset%2C%20clean%20factory%20facility%2C%20engineering%20precision%2C%20professional%20industrial%20photography%2C%20warm%20golden%20light%2C%20organized%20composition&width=800&height=500&seq=cat-indu-01&orientation=landscape',
    articleCount: 1
  }
];